/**
 * Contact form checkbox overlay
 */
$(function() {
    var inputs = $('.contact-form .box-input');

    // Swap class names on overlay based on current state of the input. The
    // class names determine whether the SVG shows a tick or a cross.
    var toggle = function(input, overlay) {
        if (input.prop('checked')) {
            overlay.addClass('yes').removeClass('no');
        } else {
            overlay.addClass('no').removeClass('yes');
        }
    };

    // No inputs, no JavaScript for you.
    if (inputs.length === 0) {
        return;
    }

    inputs.each(function(i, element) {
        var input = $(element);
        var overlay = input.siblings('.box-overlay');

        if (overlay.length === 0) {
            return;
        }

        // Show the SVG overlay and hide the input.
        overlay.css('display', 'inline-block');
        input.css('display', 'none');

        // When the input value changes, temporarily add the transition class,
        // which hides the icon with a little CSS transition. After the on/off
        // yes/no state has been checked and the overlay class name has been
        // updated, remove the transition class again to show the icon.
        input.on('change', function() {
            overlay.addClass('transition');

            window.setTimeout(function() {
                toggle(input, overlay);
            }, 200);

            window.setTimeout(function() {
                overlay.removeClass('transition');
            }, 400);
        });

        // Make the overlay link toggle the value of the underlying checkbox
        // input element.
        overlay.on('click', function(e) {
            e.preventDefault();
            input.trigger('change');
            input.prop('checked', !input.prop('checked'));
        });

        // Run the toggle function on page load as well to make sure the overlay
        // displays the correct state before anyone has clicked on it.
        toggle(input, overlay);
    });
});
